import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { AdminListSkeleton } from "@/components/skeleton/list-skeleton";
import { useTRPC } from "@/lib/trpc";
import { routes } from "@/routes";

import { ClubListItem } from "../club-list/club-list-item";

export function AdminClubsList() {
  const trpc = useTRPC();
  const { data: clubs, status } = useQuery(trpc.club.listClubs.queryOptions({ isPublic: false }));
  const { t } = useTranslation(["common"]);
  const navigate = useNavigate();

  if (status === "pending") {
    return <AdminListSkeleton />;
  }

  if (status === "error" || !clubs) {
    return (
      <span className="rounded-[18px] border border-neutral-400 bg-white p-4 text-center text-neutral-600 md:border-0">
        {t("common:no-club-found")}
      </span>
    );
  }

  return (
    <div className="pt-4">
      <div className="flex flex-col gap-2 data-[state=inactive]:hidden md:gap-0 md:rounded-[18px] md:border md:border-neutral-400">
        {clubs.map(club => (
          <ClubListItem
            key={club.id}
            club={club}
            fromPath={routes.admin}
            onClick={() => navigate(routes.getAdminClubProfilePath(club.clubRepresentativeId), { state: { fromPath: routes.admin } })}
            className="cursor-pointer"
          />
        ))}
      </div>
    </div>
  );
}
